import React, {useState} from 'react'
import useQueryLeagueDetail from '../../../hooks/api/league/useQueryLeagueDetail'
import Text from '../../../components/text/Text'
import {useTime} from '../../../utils/time'
import IconArrowDown from '../../../assets/images/ic_select_arrow.svg'
import {IUserActiveLeague} from '../../../apis/user/getUserDetail'
import {useDisplayNumber} from '../../../utils/number'
import useQueryUserDetail from '../../../hooks/api/user/useQueryUserDetail'
import WizImage from '../../../components/image/WizImage'
import useQueryExchanges from '../../../hooks/etc/useQueryExchanges'
import {IProfile} from '../../../apis/user/getUserProfile'

interface IProps {
    className?: string
    league?: IUserActiveLeague
    profile?: IProfile
}

const UserActiveLeagueItem: React.FC<IProps> = ({className, league, profile}) => {
    const {data: leagueData} = useQueryLeagueDetail(league?.league_id)
    const {localTimeString, localDateString} = useTime()
    const {floorBalance, displayAmount} = useDisplayNumber()
    const {data} = useQueryUserDetail(league?.user_id, false)
    const [isOpen, setIsOpen] = useState(false)

    const {data: ExchangeData} = useQueryExchanges(false)
    const getRenderKey = (keyId?: string) => {
        return data?.Keys?.find(list => list?.key_id === keyId)
    }
    return (
        <>
            <section className={'flex items-center justify-between gap-[10px] sm:flex-col'}>
                <Text className={`text-ti1 ${(!league?.is_active || league?.is_remove) && 'text-font_red'}`}>
                    {leagueData?.name}
                </Text>
                <Text className={'text-body2 text-font03 sm:text-body3'}>
                    {localTimeString(leagueData?.start_at)} ~ {localTimeString(leagueData?.end_at)}
                </Text>
            </section>
            <section className={'flex justify-between gap-[15px] text-center'}>
                <div>
                    <Text className={'text-ti3 text-font02'}>Init Balance</Text>
                    <Text className={'text-ti2 text-font01'}>
                        {floorBalance(
                            league?.initial_balance?.reduce((total, amount) => total + amount?.total_in_base, 0),
                        )}
                    </Text>
                    <Text className={'text-body3 text-font03'}>(Update : {localTimeString(league?.updated_at)})</Text>
                </div>
                <div>
                    <Text className={'text-ti3 text-font02'}>Balance</Text>
                    <Text className={'text-ti2 text-font01'}>{floorBalance(profile?.total_value)}</Text>
                </div>
            </section>
            <section>
                <div
                    onClick={() => {
                        setIsOpen(!isOpen)
                    }}
                    className={'flex items-center gap-x-[5px] justify-center cursor-pointer'}>
                    <Text className={'text-ti3'}>View Init API Key</Text>
                    <img
                        src={IconArrowDown}
                        className={`w-[16px] relative top-[-1px] ${isOpen ? 'transform rotate-180' : ''}`}
                    />
                </div>
                {isOpen &&
                    league?.initial_balance?.map(item => (
                        <a
                            key={item?.key_id}
                            href={`/api/detail?id=${item?.key_id}`}
                            className={
                                'cursor-pointer flex gap-x-[10px] justify-between items-center odd:bg-line04 px-[10px] py-[5px] hover:bg-line02'
                            }>
                            <div className={'flex-1'}>
                                <Text className={'text-ti3 text-font01 block'}>
                                    {getRenderKey(item?.key_id)?.name || '[No API Name]'}
                                </Text>
                                <Text className={'text-body_comm text-font03 block'}>[{item?.key_id}]</Text>
                            </div>
                            <div className={'flex items-center gap-[5px] w-[100px] sm:hidden'}>
                                <WizImage
                                    src={
                                        ExchangeData?.find(
                                            exchange => exchange?.name === getRenderKey(item?.key_id)?.exchange,
                                        )?.icon
                                    }
                                    className={'w-[16px]'}
                                />
                                <Text className={'text-ti3 text-font01 block'}>
                                    {getRenderKey(item?.key_id)?.exchange}
                                </Text>
                            </div>
                            <div className={'flex-1'}>
                                <Text className={'text-ti3 text-font01 block text-right'}>
                                    ${floorBalance(item?.total_in_base)}
                                </Text>
                                <Text
                                    className={`text-ti3 text-font01 block text-right ${
                                        getRenderKey(item?.key_id)?.balance - item?.total_in_base > 0
                                            ? 'text-font_green'
                                            : getRenderKey(item?.key_id)?.balance - item?.total_in_base < 0
                                            ? 'text-font_red'
                                            : 'text-font03'
                                    }`}>
                                    ({displayAmount(getRenderKey(item?.key_id)?.balance - item?.total_in_base)} USD)
                                </Text>
                            </div>
                        </a>
                    ))}
            </section>
        </>
    )
}

export default UserActiveLeagueItem
